<template>
  <modal :is-open="genericStore.getAlert.isOpen" :toggle="closeAlert">
    <div class="modal_alert_popup">
      <img
        src="/images/success_alert.webp"
        alt="Success alert icon"
        class="success_alert_image"
      />
      <h5 class="t-white font-family-1 title-h5 f-w-600">
        {{ genericStore.getAlert.title }}
      </h5>
      <p class="t-light font-family-2 regular-l">
        {{ genericStore.getAlert.description }}
      </p>
      <button
        class="primary filled large full-width max-width-180px b-radius-6 font-family-1 regular-m f-w-600"
        style="margin-top: 24px"
        @click.stop="closeAlert"
      >
        {{ $t("common.close") }}
      </button>
    </div>
  </modal>
</template>

<script setup>
import Modal from "./Modal.vue";

const genericStore = useGenericStore();

const closeAlert = () => {
  genericStore.resetAlert();
};
</script>
